// Module
var code = "<div ng-message=required><translate>uxf.uxf.Required</translate></div><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div>";
// Exports
module.exports = code;